module.exports = __webpack_public_path__ + "static/media/usa-laoshi7.ba1041a9.jpg";